import React from "react"
import styles from "./FeedCardSkeleton.module.scss"

const FeedCardSkeleton: React.FC = () => {
  return (
    <div className={styles.feedCardSkeleton}>
      <div className={styles.feedCardSkeletonHeader}>
        <div className={styles.feedCardSkeletonHeaderAvatar} />
        <div className={styles.feedCardSkeletonHeaderInfo}>
          <div className={styles.feedCardSkeletonHeaderInfoTitle} />
          <div className={styles.feedCardSkeletonHeaderInfoDate} />
        </div>
      </div>
      <div className={styles.feedCardSkeletonImage} />
      <div className={styles.feedCardSkeletonContent}>
        <div className={styles.feedCardSkeletonContentLine} />
        <div className={styles.feedCardSkeletonContentLine} />
        <div className={styles.feedCardSkeletonContentLine} />
        <div className={styles.feedCardSkeletonContentLineShort} />
      </div>
      <div className={styles.feedCardSkeletonFooter}>
        <div className={styles.feedCardSkeletonFooterAction} />
        <div className={styles.feedCardSkeletonFooterAction} />
      </div>
    </div>
  )
}

export default FeedCardSkeleton
